import LegalPage from '@/components/legal/LegalPage';

export default function Terms() {
  return (
    <LegalPage
      title="Terms & Conditions"
      intro="The terms that govern your use of the Quick Credit website and services."
      sections={[
        {
          heading: 'Acceptance of these terms',
          body: <p>By accessing or using this website you agree to these terms. If you do not agree, please do not use the site.</p>,
        },
        {
          heading: 'No offer of credit',
          body: (
            <p>
              Information on this site, including rates, examples and calculator results, is illustrative
              and does not constitute an offer of credit. All applications are subject to identity, credit
              and affordability checks. Approval is not guaranteed and terms offered may differ from those
              advertised.
            </p>
          ),
        },
        {
          heading: 'Your obligations',
          body: (
            <p>
              You agree to provide accurate, complete and current information, to use the site only for
              lawful purposes, and to keep your account credentials confidential. You are responsible for
              activity carried out under your account.
            </p>
          ),
        },
        {
          heading: 'Loan agreements',
          body: (
            <p>
              If your application is approved, your loan will be governed by a separate written credit
              agreement setting out the amount, APR, term, payment schedule, fees and your right to
              cancel. Those terms prevail over anything published on this website.
            </p>
          ),
        },
        {
          heading: 'Intellectual property',
          body: <p>All content, branding and software on this site belong to Quick Credit or its licensors and may not be copied or reused without permission.</p>,
        },
        {
          heading: 'Limitation of liability',
          body: (
            <p>
              We provide the website on an "as is" basis. To the extent permitted by law, we are not liable
              for indirect or consequential losses arising from use of the site. Nothing in these terms
              limits liability that cannot lawfully be limited.
            </p>
          ),
        },
        {
          heading: 'Changes',
          body: <p>We may update these terms from time to time. The version published on this page applies to your current use of the site.</p>,
        },
      ]}
    />
  );
}
